import { forkJoin, Observable, tap } from 'rxjs';
import { inject, provideAppInitializer } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LocaleService } from '@services/locale.service';
import { MapsService } from '@services/maps.service';
import { AuthenticationService } from '../services/authentication.service';
import { EnvironmentService } from '../services/environment.service';
import { MixpanelService } from '../services/mixpanel.service';

export const appInitProvider = provideAppInitializer(() => {
  const authenticationService = inject(AuthenticationService);
  const environmentService = inject(EnvironmentService);
  const mixpanelService = inject(MixpanelService);
  const mapsService = inject(MapsService);
  const localeService = inject(LocaleService);

  return forkJoin([
    environmentService.init().pipe(
      tap((config) => {
        mixpanelService.init();
        mapsService.loadGoogleMapsApi(config.apiUrlEntity.googleApiKey).catch((error) => {
          Sentry.captureException(error);
        });
      }),
    ),
    new Observable((observer) => {
      authenticationService.initUserToken();
      localeService.initLocale();
      observer.next(undefined);
      observer.complete();
    }),
  ]);
});
